import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AddRebid from './AddRebid';
import Preview from './Preview';

const RebidSubmission = () => {
    const [tender, setTender] = useState();
    const [workItems, setWorkItems] = useState();
    const [step, setStep] = useState(1)
    const storedUser = JSON.parse(localStorage.getItem("user"))
    const {rfqId} = useParams();

    useEffect(() => {
      const getTender = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/rfq/get-by-id?rfqId=${rfqId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTender(res.data);
          setWorkItems(res.data.rfqWorkItems.map((item) => ({ ...item, rate: 0, total: 0, currency: null })));
        } catch (error) {
          console.error(error);
        }
      };
      getTender();
    }, []);

  return (
    <div>
      {tender &&
      <div>
            {step === 1 && <AddRebid rfq={tender} data={workItems} setData={setWorkItems} setStep={setStep} user={storedUser}/>}
            {step === 2 && <Preview rfq={tender} setStep={setStep} data={workItems} user={storedUser}/>}
      </div>}
    </div>
  )
}

export default RebidSubmission